import {useState,useEffect} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import {Loader1} from '../../components/loaderComp';
import {userservices} from '../../services/userServices';
import {productservices} from '../../services/productServices';
import {Titlebar,Searchbox,Confirmdialog} from  '../../components/fieldsComp';
import { localurl } from '../../constant';
import { Dialog } from 'primereact/dialog';
import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
const ProductTracking = () =>{

    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [ingredients,setIngredients] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    const [visible, setVisible] = useState(false);
    const [productdetail, setProductDetail] = useState(false);
    const [productdetailinfo, setProductDetailinfo] = useState({});
    const [productid, setProductid] = useState('');

    const [popvisible, setPopvisible] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10); // 🔄 dynamic page size
    const [orderBy, setOrderBy] = useState('most');
    
    const [quickFilterText, setQuickFilterText] = useState('');

    useEffect(()=>{
      getbulkproduct(currentPage,pageSize);
    },[currentPage,pageSize]); 

    useEffect(() => {
        setColDefs(getColDefs(currentPage, pageSize));
    }, [currentPage, pageSize]);

          const handleNext = () => {
      if (currentPage < Math.ceil(totalRows / pageSize)) {
        setCurrentPage(currentPage + 1);
      }
    };
  
    const handlePrevious = () => {
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
    };

    const orderStatusBy = (val) => {
        setOrderBy(val);
        getbulkproduct(1, pageSize)
    }
  
  const getColDefs = (currentPage, pageSize) => [
    {
      headerName: "SR NO",
      width:100,
      valueGetter: (params) => {
        return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
      },
    },
    { headerName: "Product Name",field: "product_name" },
    { headerName: "Master SKU Code",field: "sku_code",cellRenderer: (params) => {
        return (
             params.getValue()
            // <Tag severity="success" value={params.getValue()} rounded></Tag>
        );
      } },
    { headerName: "Created On",field: "created_at" },
    // {headerName:"Unit Will Produce",field:"unitproduced",cellRenderer: (params) => {
    //     return (
    //           <>
    //           {params.data.unitproduced != undefined ? (<>
               
    //               {params.data.unitproduced}&nbsp;
    //               <span className='text-success'>(unit)</span> 
                 
    //           </>) : (<></>)}  
    //           </>
               
            
    //     );
    //   }}, 
    // { headerName: "Total Stocks",field: "total_stock",
    //   cellRenderer: (params) => {
    //     return (<>
    //         {params.data.total_stock != null ? (<> {params.data.total_stock} &nbsp; <span className='text-success'>({params.data.unit_of_measurement})</span> </>) : <></>}  
    //           </>     
                
          
    //     );
    //   }
    // },
    { headerName: "Sold Units",field: "totalunit_sold",
      cellRenderer: (params) => {
        return (<>
            {params.data.totalunit_sold != null ? (<> {params.data.totalunit_sold} &nbsp; <span className='text-success'>({params.data.unit_of_measurement})</span> </>) : <></>}  
              </>     
        );
      }
    },
    // { headerName: "Avl Stock",field: "availstock",
    //   cellRenderer: (params) => {
    //     return (
    //         <>
    //         {params.getValue() != null ? (<>{params.getValue()} &nbsp; <span className='text-success'>({params.data.unit_of_measurement})</span> </>) : <></>}  
    //           </> 
         
    //     );
    //   }
    // },

    
      
    { headerName: "Notes",field: "notes" },
    { headerName: "Category", field: "category_name"},
    { headerName: "Action",
    cellRenderer: (params) => {
      // console.log("params");
      // console.log(params.data.id);
      return (
        <>
             {/* <button class="btn  btn-xs btn-white custom-btn-color2" onClick={(e) => editredirect(params.data.id)}>
               <i class="icon icon-note color-white" title="Edit Product" onClick={(e) => editredirect(params.data.id)} ></i>
              </button>
             &nbsp;
             <button class="btn  btn-xs btn-white btn-danger">
              <i class="icon icon-trash color-white" title="Delete Product" onClick={(e) =>{setPopvisible(true);setProductid(params.data.id)} }></i>
              </button>
              &nbsp; */}
              <button class="btn  btn-xs btn-white btn-success">
              <i class="icon icon-eye color-white" title="Product Detail" onClick={(e) => {setProductDetail(true);setProductDetailinfo(params.data);getDetail(params.data.id);}}></i>
             </button> 
        </>
       
      );
    } }
  ];
  
  const [colDefs, setColDefs] = useState(getColDefs(1, 5));



  const deleteproduct = (id) => {
    productservices.deleteproduct(id).then((response)=>{
         if(response.status == 200){
              // console.log("product deleted");
              getbulkproduct(currentPage,pageSize);
              setPopvisible(false);
              //  toast.current.show({ severity: 'success', summary: 'Component', detail: 'Component created successfully' }); 
         }else{
             console.log("product not deleted");
         }
    });
  }

  const editredirect = (id) =>{
    navigate(`/editproduct/${id}`);
  }


  const getbulkproduct  = (page,pageSize)=> {
        setUserloaded(true);
        productservices.getproducttrackingdata(page,pageSize, orderBy).then((response)=>{
            if(response.status == 200){
                setResults(response.data.data);
                setTotalRows(response.data.total);
                setCurrentPage(response.data.current_page);
              // console.log(response.data.data);
              //   setUsers(response.data.data);
                setUserloaded(false);
            }else{
              setResults([]);
                // setUsers([]);
                // setUserloaded(true);
                setUserloaded(false);
            }  
        }).catch((error)=>{
          setResults([]);
          setUserloaded(false);
            // setUsers([]);
           setUserloaded(false);
        }); 
  } 


  async function getDetail(id){
     
      let response = await productservices.getbllofmaterialDetail(id);
      // console.log("details ");
      // console.log(response); 
      console.log(response.data.data);
      if(response.status == 200){
        // console.log("response");
        
            setIngredients(response.data.data);   
      }else{
            setIngredients([]);
      }
   }

   function displayIngredients(){
        let arr = [];
        ingredients.forEach((value,index) =>{
          // console.log(value.component);
            arr.push(<tr> 
                          <td>{index + 1}</td>
                          <td>{value.component}</td>
                          <td>{value.componentSkuCode}</td>
                          <td>{value.billofmaterial_qty} &nbsp;<span className='text-success'>({value.billofmaterial_units})</span></td>
                          <td>{value.total_qty} &nbsp;<span className='text-success'>({value.unit})</span></td>
                      </tr>);
        })

        return arr;
   }

const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    getbulkproduct(1, newSize);       // reload with new size
  };
  return(
       <>
          {/* <Bredcrum title={'Product '} divider={false}/> */}
          <div class="row">
              <div className='col-md-12 mb-2 mt-2'>
                 <div className='flex-box flex-between'>
                        <div>
                            <Titlebar text={'Product Tracking'}/>
                        </div>
                        <div>      
                            <select class="form-control" onChange={(e) => orderStatusBy(e.target.value)} value={orderBy}>
                                <option value="most">Most Product Sold</option>
                                <option value="least">Least Product Sold</option>
                            </select>
                        </div>
                      <Searchbox value={quickFilterText} onChange={(e) => setQuickFilterText(e.target.value)}/>
                  </div> 
              </div> 

              <Dialog visible={visible} position='top' modal style={{ width: '50rem' }} onHide={() => { if (!visible) return; setVisible(false); }}>
                  <div className="container py-5">
                      <div className="card shadow-lg rounded-4 p-4">
                          <h2 className="mb-4 text-center text-primary">Excel Multiple Data Upload</h2>

                          <div className="text-center mb-4">
                              <a
                                  href={localurl + "/templates/component.xlsx"}
                                  download
                                  className="btn btn-outline-primary rounded-pill px-4"
                                  target="_blank"
                                  rel="noopener noreferrer"
                              >
                                  Download Excel Template
                              </a>
                          </div>

                          <form id="uploadForm" onSubmit={()=>{}}>
                              <div className="mb-3">
                                  <label htmlFor="file" className="form-label fw-semibold">
                                      Upload Excel File
                                  </label>
                                  <input
                                      type="file"
                                      className="form-control form-control-lg"
                                      id="file"
                                      name="file"
                                      accept=".xlsx, .xls"
                                      required
                                  />
                              </div>

                              <div className="text-center">
                                  <button
                                      type="submit"
                                      className="btn btn-primary rounded-pill px-5 py-2 custom-btn-color"
                                  >
                                      Upload
                                  </button>
                              </div>
                          </form>

                          <div id="status" className="status mt-4 text-center text-success fw-medium"></div>
                      </div>
                  </div>

              </Dialog>

              <Dialog visible={productdetail} position='top' modal style={{ width: '80rem' }} onHide={() => {if (!productdetail) return; setProductDetail(false); }}>
                    <div class="container">
                          <table className='table-bordered'>
                              
                              <tbody>
                                  <tr>
                                      <th colSpan={5}><h3 className='text-success'>Product : </h3></th>
                                  </tr>
                                  <tr>
                                      <th>Product</th>
                                      <th>SKU Code</th>
                                      <th>Product Status</th>
                                      <th>QR CODE</th>
                                      <th></th>
                                  </tr>
                                  <tr>
                                      <td >{productdetailinfo.product_name}</td>
                                      <td>{productdetailinfo.sku_code}</td>
                                      <td>{productdetailinfo.stock_type == 'finished' ? (<Tag severity="success" value={productdetailinfo.stock_type}></Tag>) : <>N/A</>} </td>
                                      <td>
                                        {productdetailinfo.qr_code_path ? (
                                          <img
                                            src={`${localurl}/${productdetailinfo.qr_code_path}`}
                                            alt="QR Code"
                                            style={{ width: '100px', height: '100px', objectFit: 'contain' }}
                                          />
                                        ) : (
                                          <>N/A</>
                                        )}
                                      </td>
                                      <td></td>  

                                  </tr>
                                   <tr>
                                      <th colSpan={5}><h3 className='text-success'>Ingredient Used  : </h3></th>
                                      
                                  </tr>
                                  <tr>
                                      <th>Sr No</th>  
                                      <th>Component</th>
                                      <th>Component SKU Code</th>
                                      <th>Bill of Material Qty</th>
                                      {/* <th>Bill of Material Units</th> */}
                                      <th>Total Units In Stock</th>
                                  </tr>

                                  {displayIngredients()}
                                  {/* <Loader1/> */}
                              </tbody>
                          </table>     
                    </div>
              </Dialog>

              <Confirmdialog popvisible={popvisible} setPopvisible={setPopvisible} fun={deleteproduct} id={productid}/>

              
              {/* <Titlebar text={'Product Master'}/> */}
              <div className="col-md-12 mt-3">
                  <div className='card'>
                    <div className='card-body card-body-style'>
                     <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText}
                      paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                     totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext} 
                     handlePrevious={handlePrevious}
                     handlePageSizeChange={handlePageSizeChange}
                     />
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default ProductTracking;